import { ElementType } from "react";

import { Column, Row, Text } from "@/components";
import { Card } from "@/components/ui/card";

// One stat card in a sourcing funnel: label, count, caption, and a stage icon.
export const SourcingFunnelCard = ({
  caption,
  Icon,
  label,
  value,
}: {
  caption: string;
  Icon: ElementType;
  label: string;
  value: number;
}) => {
  return (
    <Card className="min-h-[120px] flex-1 p-5 shadow-none">
      <Row className="items-start justify-between gap-4">
        <Column className="gap-1">
          <Text className="text-sm font-medium text-slate-500">{label}</Text>
          <Text className="text-2xl font-semibold text-slate-900">{value}</Text>
          <Text className="text-xs font-normal text-slate-500">{caption}</Text>
        </Column>
        <Row className="h-9 w-9 shrink-0 items-center justify-center rounded-md bg-primary-100 text-primary-700">
          <Icon className="h-4 w-4" />
        </Row>
      </Row>
    </Card>
  );
};
